/**
 * The addressable leaves that inhabit one Cleo world view. Keeping this pure
 * prevents the root shell and the nested chat layout from inventing different
 * answers about whether the complete Session boundary is present.
 */
export function worldViewFrameKind(pathname: string): "session" | "bare" {
  const segments = pathname.split("/").filter((segment) => segment.length > 0);
  if (segments.length === 0) return "bare";
  if (
    segments[0] === "pull-requests" ||
    segments[0] === "settings" ||
    segments[0] === "projects" ||
    segments[0] === "connect_"
  ) {
    return "bare";
  }
  if (segments[0] === "draft") return segments.length === 2 ? "session" : "bare";
  return segments.length === 2 ? "session" : "bare";
}

/** The addressed leaf shared by browser and Electron/hash history. */
export function parseSessionSessionLeafPath(
  pathname: string,
):
  | { readonly kind: "thread"; readonly environmentId: string; readonly threadId: string }
  | { readonly kind: "draft"; readonly draftId: string }
  | { readonly kind: "session"; readonly sessionId: string }
  | null {
  if (worldViewFrameKind(pathname) !== "session") return null;
  const [first, second] = pathname.split("/").filter((segment) => segment.length > 0) as [
    string,
    string,
  ];
  if (first === "draft") return { kind: "draft", draftId: decodeURIComponent(second) };
  if (first === "session") return { kind: "session", sessionId: decodeURIComponent(second) };
  return {
    kind: "thread",
    environmentId: decodeURIComponent(first),
    threadId: decodeURIComponent(second),
  };
}
